import { Component, Input } from '@angular/core';

export enum EaIconType {
  MATERIAL,
  FONTAWESOME,
  SPRITE,
  FLAGSPRITE,
}

@Component({
    selector: 'pr-icon',
    templateUrl: './pr-icon.component.html',
    styleUrls: ['./pr-icon.component.scss'],
    standalone: false
})
export class PrIconComponent {
  EaIconType = EaIconType;
  @Input() name: string;
  @Input() tooltip: string;
  @Input() width: number = 20;
  @Input() height;
  @Input() viewBoxWidth = 20;
  @Input() viewBoxHeight = 20;

  constructor() {}

  get type() {
    if (!this.name) return;
    return this.name.startsWith('fa-')
      ? EaIconType.FONTAWESOME
      : this.name.startsWith('sp-')
        ? EaIconType.SPRITE
        : this.name.startsWith('fs-')
          ? EaIconType.FLAGSPRITE
          : EaIconType.MATERIAL;
  }

  get icon() {
    if (!this.name) return;
    return [EaIconType.SPRITE, EaIconType.FLAGSPRITE].includes(this.type)
      ? this.name.substr(3)
      : this.name;
  }
}
